import { styled } from '@mui/material/styles';
import { Button as BaseButton } from 'components/buttons';

export const AttachmentContainer = styled('div')(() => ({
  position: 'relative'
}));

export const FileUploadComponent = styled('input')(() => ({
  position: 'absolute',
  top: '0px',
  left: '0px',
  maxWidth: '100%',
  width: '100%',
  height: '55px',
  opacity: 0
}));

export const UploadButton = styled(BaseButton)(() => ({
  width: '100%',
  marginBottom: '5px'
}));

export const List = styled('ol')(({ $mt }) => ({
  marginTop: $mt ? `${$mt}px` : '0px',
  paddingInlineStart: '20px'
}));

export const ListItem = styled('li')(({ theme, $mt, $bold }) => ({
  marginTop: $mt ? `${$mt}px` : '0px',
  paddingLeft: '10px',
  color: theme.color.primary.main,
  fontWeight: $bold ? theme.fontWeight.bold : theme.fontWeight.normal
}));
